import React from 'react';

export default {
  1: {
    title: [
      <p key="error-1-title1">페이지를 연결할 수 없습니다.</p>,
      <p key="error-1-title2">잠시 후 다시 시도해주세요.</p>,
    ],
    content: [
      <p key="error-1-content1">동일한 문제가 계속 발생하는 경우</p>,
      <p key="error-1-content2">
        아래 <span className="text-primary">고객지원</span>을 통해 문의해주세요.
      </p>,
    ],
  },
  2: {
    title: [
      <p key="error-2-title1">알 수 없는 인증 요청입니다.</p>,
      <p key="error-2-title2">해당 요청에 대해서는</p>,
      <p key="error-2-title3">인증 서비스를 제공하지 않습니다.</p>,
    ],
    content: [
      <p key="error-2-content1">동일한 문제가 계속 발생하는 경우</p>,
      <p key="error-2-content2">
        아래 <span className="text-primary">고객지원</span>을 통해 문의해주세요.
      </p>,
    ],
  },
  3: {
    title: [
      <p key="error-3-title1">반복적인 인증 요청으로</p>,
      <p key="error-3-title2">접근이 제한되었습니다.</p>,
      <p key="error-3-title3">잠시 후 다시 시도해주세요.</p>,
    ],
    content: [
      <p key="error-3-content1">동일한 문제가 계속 발생하는 경우</p>,
      <p key="error-3-content2">
        아래 <span className="text-primary">고객지원</span>을 통해 문의해주세요.
      </p>,
    ],
  },
};
